











































import Vue from 'vue';
import { PropOptions } from 'vue/types/options';

export default Vue.extend({
  name: 'SearchForm',
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    isSearchByGroup: {
      type: String,
    },
  },
  data() {
    return {
      searchValue: '',
      searchType: 'groupName',
      formValid: false,
      searchOptions: [
        {
          value: 'groupName',
          text: 'Group Name',
        },
        {
          value: 'groupNumber',
          text: 'Group Number',
        },
      ],
      userRole: 'GrpAdmn',
      userRoles: [
        {
          value: 'GrpAdmn',
          text: 'Group Admin',
        },
        {
          value: 'GrpEdit',
          text: 'Group Edit',
        },
        {
          value: 'GrpView',
          text: 'Group View',
        },
      ],
      rules: {
        search(value: string, type: string): string | boolean {
          if (value.length === 0) {
            return 'Please enter your search criteria.';
          } else if (type === 'groupName') {
            return (
              value.length >= 4 || 'Group name must be more than 4 characters'
            );
          } else if (type === 'groupNumber') {
            const ALPHANUMERIC_REGEX = /^[a-z0-9]*$/i;
            return (
              ALPHANUMERIC_REGEX.test(value) ||
              'Group number must be alphanumeric'
            );
          }

          return true;
        },
      },
    };
  },
  computed: {
    isFindActive(): boolean {
      return (
        !this.searchValue.length ||
        !this.searchType ||
        !this.userRole ||
        this.isLoading ||
        !this.formValid
      );
    },
    searchByGroup(): boolean {
      if (this.isSearchByGroup === 'group') {
        this.searchValue = '';
        this.searchType = 'groupName';
        return true;
      } else {
        this.searchValue = '';
        this.searchType = 'contactName';
        return false;
      }
    },
    searchTypeLabel(): string {
      return this.searchByGroup ? 'Search Group' : 'Search Group Contact';
    },
  },
  methods: {
    submitSearch() {
      this.$emit('searchSubmitted', {
        GroupSearchCriteria: this.searchValue,
        GroupSearchBy: this.searchType,
        Role: this.userRole,
      });
    },
    resetSearch() {
      this.searchType = this.searchByGroup ? 'groupName' : 'contactName';
      this.userRole = 'GrpAdmn';
      this.searchValue = '';
      (this.$refs.searchForm as any).resetValidation();
      this.$emit('reset');
    },
  },
});
